import type {
  TranslateOptions,
  TranslationFn,
  TranslationStringMap,
} from './types';

export const createTranslationFn = <T extends string>(
  stringMap: TranslationStringMap
): TranslationFn<T> => {
  return (key: T, options: TranslateOptions = {}) => {
    const {context, contextCondition = true, ...stringArgs} = options;

    const maybeKeyWithContext =
      context && contextCondition ? `${key}_${context}` : `${key}`;

    const stringValue = stringMap[maybeKeyWithContext] || stringMap[key];
    if (!stringValue) return key;

    return interpolateStringArgs(stringValue, stringArgs);
  };
};

/**
 * Replaces string arguments by matching the `{{key}}` pattern in a string, and looking up
 * the argument matching `key` in the provided `args` object.
 */
const interpolateStringArgs = (
  value: string,
  args: {
    [key: string]: string | number | boolean | undefined;
  }
): string => {
  const result = value
    // Replace `{{key}}` argument patterns
    .replace(/{{(.+?)}}/g, (_, matchedKey) => {
      const replaceWith = `${args[matchedKey] || ''}`;
      return replaceWith;
    })
    // Replace double spaces with a single space
    .replace(/  +/g, ' ')
    // Trim whitespace in strings
    .trim();

  return result;
};
